var map = {
	"./en-GB.json": [
		80264,
		264
	],
	"./en-NL.json": [
		62207,
		2207
	],
	"./fr-BE.json": [
		7953,
		7953
	],
	"./nl-BE.json": [
		3791,
		3791
	],
	"./nl-NL.json": [
		42212,
		2212
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 53575;
module.exports = webpackAsyncContext;